<template>
    <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content-sl" name="ModalScontiLogistici">
        <div class="DiscountPopup MyBody">
            <div class="PackagingDiscountBox">
                <div class="PackagingDiscountIcon"><img src="/images/DiscountIconYellow.svg" alt="" /></div>
                <div class="PackagingDiscountText">
                    <h2>Testo spiegazione sconto su acquisti multipli/confezioni</h2>
                    <div>
                        <p>{{ this.Message }}</p>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>

import {risorseMixin} from "@/mixin.js";

export default { 
    name: "ModalScontiLogistici",
    props:{
        ScontoLogistico: Number,
        PezziConfezione: Number
    },
    data(){
        return {
            showModal: false
        }
    },
    computed:{
        Message: function(){
            return this.risorse["ScontoDel"] + this.ScontoLogistico +"%" + this.risorse["ScontoDel_1"] + this.PezziConfezione +this.risorse["ScontoDel_2"]+ this.PezziConfezione;
        }
    },
    mixins:[risorseMixin],
    methods:{
        closeModal: function(){
            this.$vfm.hide('ModalScontiLogistici');
        },

    }
}
</script>
<style>

.MyBody{
    font-family: 'Exo', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #101820;
}

.modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-content-sl {
    max-width: 800px;
    display: flex;
    flex-direction: column;
    margin: 0 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;
}

.textMsg{
    padding: 20px 0 20px 0;
    text-align: center;
}

</style>